import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { RootState } from '../../store/index';
import { imageUrl, zeusApp } from '../../request/index';
import { CopyOutlined, ApartmentOutlined, DatabaseOutlined, AccountBookOutlined, MutedOutlined } from '@ant-design/icons';
import MineBottom from '../../components/bottom-mine'
import Management from '../../components/mine/management'
import Notifications from '../../components/mine/notifications'
import ChooseCompany from '../../components/mine/choosecompany'
import OrderCenter from '../../components/mine/ordercenter'
import WorkOrder from '../../components/mine/workorder'
import MineInformation from '../../components/mine/mineinformation'
import CheckOrder from '../../components/mine/checkorder'
import ChooseManagement from '../../components/mine/choosemanagement'
import PayOrder from '../../components/mine/payorder'
import { apiGetMineInfo } from '../../request/api'
import ManagementDetail from '../../components/mine/managementdetail'
import ManageInvoices from '../../components/mine/manageInvoices'
import AddManagement from '../../components/mine/addmanagement'
import { useCustomData } from '../../pages/context/mineCustomDataProvider';


interface mineInfo {
    name: string;
    headImg: string; 
}

interface infoState {
    icon: React.ElementType;
    view: string;
    name: string | undefined;
}
const MineIndex: React.FC = () => {
    const themeColor = useSelector((state: RootState) => state.themeColor.value);
    const navigate = useNavigate();
    const [currentView, setCurrentView] = useState('choosecompany');
    const [selectedIndex, setSelectedIndex] = useState(0);
    const [mineInfo, setMineInfo] = useState<mineInfo>()

    const [viewData, setViewData] = useState(null);
    const token = window.localStorage.getItem('userToken') || window.sessionStorage.getItem('userToken');

    const { getValue } = useCustomData();
    const workOrder = getValue('workOrder');
    const chooseCampany = getValue('chooseCampany');
    const orderCenter = getValue('orderCenter');
    const pushManager = getValue('pushManager');
    const notifications = getValue('notifications');
    const [mineChooseList, setMineChooseList] = useState<infoState[]>([]);

    useEffect(() => {
        setMineChooseList([
            { icon: ApartmentOutlined, name: chooseCampany, view: 'choosecompany' },
            { icon: CopyOutlined, name: workOrder, view: 'workorder' },
            { icon: DatabaseOutlined, name: orderCenter, view: 'ordercenter' },
            { icon: AccountBookOutlined, name: pushManager, view: 'management' },
            { icon: MutedOutlined, name: notifications, view: 'notifications' }
        ]);
    }, [chooseCampany, workOrder, orderCenter, pushManager, notifications]);

    const renderView = () => {
        switch (currentView) {
            // 选择公司
            case 'choosecompany':
                return <ChooseCompany handleViewChange={handleViewChange} data={viewData} />;
            // 发票管理
            case 'management':
                return <Management handleViewChange={handleViewChange} data={viewData} />;
            // 通知中心
            case 'notifications':
                return <Notifications handleViewChange={handleViewChange} data={viewData} />;
            // 订单中心
            case 'ordercenter':
                return <OrderCenter handleViewChange={handleViewChange} data={viewData} />;
            // 工单管理
            case 'workorder':
                return <WorkOrder handleViewChange={handleViewChange} data={viewData} />;
            // 个人信息
            case 'mineinformation':
                return <MineInformation handleViewChange={handleViewChange} data={viewData} refreshMineInfo={refreshMineInfo} />;
            // 订单查看
            case 'checkorder':
                return <CheckOrder handleViewChange={handleViewChange} data={viewData} />;
            // 支付订单
            case 'payorder':
                return <PayOrder handleViewChange={handleViewChange} data={viewData} />;
            // 选择开票信息
            case 'choosemanagement':
                return <ChooseManagement handleViewChange={handleViewChange} data={viewData} />;
            // 查看开票信息
            case 'managementdetail':
                return <ManagementDetail handleViewChange={handleViewChange} data={viewData} />;
            // 发票信息管理
            case 'manageinvoices':
                return <ManageInvoices handleViewChange={handleViewChange} data={viewData} />;
            // 新增发票
            case 'addmanagement':
                return <AddManagement handleViewChange={handleViewChange} data={viewData} />;

            default:
                return <ChooseCompany handleViewChange={handleViewChange} data={viewData} />;
        }

    }
    useEffect(() => {
        refreshMineInfo();
        apiGetMineInfo().then(res => {
            if (res.data.data === null) {
                navigate("/login")
            }
        })
    }, [token]);


    const refreshMineInfo = () => {
        apiGetMineInfo().then(res => {
            setMineInfo(res.data.data);
        })
    };

    const handleViewChange = (newView: string, data?: any) => {
        setCurrentView(newView);
        setViewData(data);
    };

    const handleItemClick = (index: number, view: string) => {
        setSelectedIndex(index);
        setCurrentView(view);
    };
    return (

        <div className='Mine'>
            <div className="mine-content">
                <div className='mine-left'>
                    <div className='mine-usercon' onClick={() => handleItemClick(7, 'mineinformation')}>
                        <img src={`${imageUrl}${mineInfo?.headImg}?zeus-app=${zeusApp}`} />
                    </div>
                    <div className='username'>{mineInfo?.name}</div>
                    {mineChooseList.map((item, index) => (
                        <div key={index}
                            className={`mine-choose-item ${index === selectedIndex ? 'selected' : ''}`}
                            style={{ color: index === selectedIndex ? themeColor : 'inherit' }}
                            onClick={() => handleItemClick(index, item.view)}
                        >
                            <item.icon />
                            <span>{item.name}</span>
                        </div>
                    ))}
                </div>
                <div className='mine-right'>
                    {renderView()}
                </div>
            </div>
            <MineBottom />
        </div>
    );
};

export default MineIndex;